module.exports = {"Step":"مرحله","Person":"نفر"}